import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

// Public
export const fetchColleges = (params = {}) => api.get('/colleges', { params }).then((r) => r.data);
export const fetchCollege = (id) => api.get(`/colleges/${id}`).then((r) => r.data);
export const fetchUniversities = () => api.get('/universities').then((r) => r.data);
export const fetchUniversity = (id) => api.get(`/universities/${id}`).then((r) => r.data);
export const fetchCourses = () => api.get('/courses').then((r) => r.data);
export const fetchCourse = (id) => api.get(`/courses/${id}`).then((r) => r.data);
export const fetchExams = (params = {}) => api.get('/exams', { params }).then((r) => r.data);
export const fetchExam = (id) => api.get(`/exams/${id}`).then((r) => r.data);
export const fetchBlogs = (params = {}) => api.get('/blogs', { params }).then((r) => r.data);
export const fetchBlog = (id) => api.get(`/blogs/${id}`).then((r) => r.data);
export const fetchAuthors = () => api.get('/authors').then((r) => r.data);
export const fetchAuthor = (id) => api.get(`/authors/${id}`).then((r) => r.data);

// Auth
export const postSession = (session_id) => api.post('/auth/session', { session_id }).then((r) => r.data);
export const getMe = () => api.get('/auth/me').then((r) => r.data);
export const logout = () => api.post('/auth/logout').then((r) => r.data);

// Admin
export const adminList = (entity) => api.get(`/admin/${entity}`).then((r) => r.data);
export const adminCreate = (entity, payload) => api.post(`/admin/${entity}`, payload).then((r) => r.data);
export const adminUpdate = (entity, id, payload) => api.put(`/admin/${entity}/${id}`, payload).then((r) => r.data);
export const adminDelete = (entity, id) => api.delete(`/admin/${entity}/${id}`).then((r) => r.data);
export const adminStats = () => api.get('/admin/stats/overview').then((r) => r.data);
